var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div class=\"downtimeWarnings\">\n  <div ng-if=\"downtime.display('first')\" class=\"warning first\"><span>{{ t('pageDowntimePlanned', downtime.localDowntime(), downtime.estimatedDownTimeMinutes) }}</span><a ng-click=\"downtime.hide('first')\" class=\"close\"></a></div>\n  <div ng-if=\"downtime.display('final')\" class=\"warning final\"><span>{{ t('pageDowntimePlanned', downtime.formatDowntime(), downtime.estimatedDownTimeMinutes) }}</span><a ng-click=\"downtime.hide('final')\" class=\"close\"></a></div>\n  <div ng-if=\"downtime.display('general')\" class=\"warning general\"><span>{{ t('pageDowntimeGeneral') }}</span><a ng-click=\"downtime.hide('general')\" class=\"close\"></a></div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/downtimeWarnings.jade
 ** module id = 75
 ** module chunks = 1
 **/